import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleCrossed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbleCrossed"><Path fillRule="evenodd" clipRule="evenodd" d="M21.002 3V19.0357L15.3757 19.0358L11.9939 21.8375L8.65157 19.0358H3.00195V3.00003L21.002 3ZM15.414 9L13.9998 7.58579L11.9998 9.58579L9.99976 7.58579L8.58554 9L10.5855 11L8.58554 13L9.99976 14.4142L11.9998 12.4142L13.9998 14.4142L15.414 13L13.414 11L15.414 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleCrossed;
